module.exports = __webpack_public_path__ + "static/media/1.00ac7da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/HIFEM/Images/1.png
// module id = 700
// module chunks = 0